/// <reference types="./adminSearchEntities.d.ts" />
import { ok, } from '@dossierhq/core';
import { authResolveAuthorizationKeys } from '../Auth.js';
import { decodeAdminEntity } from '../EntityCodec.js';
import { fetchAndDecodeConnection } from '../utils/fetchAndDecodeConnection.js';
export async function adminSearchEntities(schema, authorizationAdapter, databaseAdapter, context, query, paging) {
    const authKeysResult = await authResolveAuthorizationKeys(authorizationAdapter, context, query?.authKeys);
    if (authKeysResult.isError())
        return authKeysResult;
    const authKeys = authKeysResult.value;
    if (authKeys.length === 0) {
        // User requested with authKeys, but they resolved to nothing, so we won't match any entity
        return ok(null);
    }
    return fetchAndDecodeConnection(paging, (pagingInfo) => databaseAdapter.adminEntitySearchEntities(schema, context, query, pagingInfo, authKeys), (edge) => decodeAdminEntity(schema, edge));
}
//# sourceMappingURL=adminSearchEntities.js.map